import { Component } from '@angular/core';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {PresentsTabsEnums} from '../../../enums/presents-enums';
import {PresentsHttpService} from '../../../services/http-services/presents/presents-http.service';
import {ActivatedRoute, Router} from "@angular/router";
import {PresentStateService} from "../../../services/helpers/present-state.service";

@Component({
  selector: 'app-presents',
  templateUrl: './presents.component.html',
})
export class PresentsComponent {
  isCreateToyStoreModalOpen = false;
  isUploadPresentsTableModalOpen = false;
  isAddPresentsActionModalOpen = false;
  isPresentsTableChanged = false;
  activeTab = PresentsTabsEnums.profile;
  stores: any[] = [];
  checkedPresentIds: number[] = [];
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;
  protected readonly PresentsTabsEnums = PresentsTabsEnums;

  constructor(
    private presentsHttpService: PresentsHttpService,
    private route: ActivatedRoute,
    private router: Router,
    private presentStateService: PresentStateService
  ) {}

  ngOnInit(): void {
    this.getToyStores();
    this.route.queryParams.subscribe(params => {
      const tabParam = params['tab'];

      if (tabParam) {
        this.activeTab = tabParam as PresentsTabsEnums;
      } else {
        const savedTab = this.presentStateService.getListState()?.tab;
        this.activeTab = savedTab || PresentsTabsEnums.profile;
      }
    });
  }

  getToyStores(): void {
    this.presentsHttpService.getToyStores().then(res => {
      this.stores = res.data;
    });
  }

  onConfirmCreateToyStore(store: any): void {
    this.stores.push(store);
    this.isCreateToyStoreModalOpen = false;
  }

  onNewPresentsTableUploaded(): void {
    this.isUploadPresentsTableModalOpen = false;
    this.isPresentsTableChanged = true;
    setTimeout(() => {
      this.isPresentsTableChanged = false;
    }, 3000);
  }

  onConfirmAddPresentAction(): void {
    this.isAddPresentsActionModalOpen = false;
    this.isPresentsTableChanged = true;
    setTimeout(() => {
      this.isPresentsTableChanged = false;
    }, 3000);
  }

  selectTab(tab: PresentsTabsEnums): void {
    this.activeTab = tab;

    const isNonPresentsTab = [PresentsTabsEnums.profile, PresentsTabsEnums.stores].includes(tab);

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: isNonPresentsTab ? { tab } : { ...this.route.snapshot.queryParams, tab },
      queryParamsHandling: isNonPresentsTab ? '' : '',
      replaceUrl: true
    });
  }

}
